"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useCurrentAnswers = require("../../hooks/questionnaire/useCurrentAnswers");
var _useCurrentQuestion = require("../../hooks/questionnaire/useCurrentQuestion");
var _utils = require("../../utils/utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  white-space: pre-line;
`;
const StyledTitle = _styledComponents.default.div`

  & h3, & h2{
   line-height:${prop => prop.smallHeadingLineHeight}px;
    @media (min-width: 768px){
      font-size: ${prop => prop.titleHeadingDesktopFontSize}px;
      line-height:${prop => prop.largeHeadingLineHeight}px;
    }
  }
`;
const QuestionTitle = () => {
  const {
    answers
  } = (0, _useCurrentAnswers.useCurrentAnswers)();
  const {
    title,
    subtitle,
    topTitle
  } = (0, _useCurrentQuestion.useCurrentQuestion)();
  const titleHeadingLevel = (0, _useLocalTheme.default)('titleHeadingLevel', 2);
  const titleHeadingDesktopFontSize = (0, _useLocalTheme.default)('titleHeadingDesktopFontSize');
  const largeTitleHeadingLineHeight = (0, _useLocalTheme.default)('largeTitleHeadingLineHeight', 40);
  const smallTitleHeadingLineHeight = (0, _useLocalTheme.default)('smallTitleHeadingLineHeight', 32);
  const largeSubtitleHeadingLineHeight = (0, _useLocalTheme.default)('largeSubtitleHeadingLineHeight', 28);
  const smallSubtitleHeadingLineHeight = (0, _useLocalTheme.default)('smallSubtitleHeadingLineHeight', 26);
  const titleHeadingSize = (0, _useLocalTheme.default)('titleHeadingSize', 2);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, topTitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: (0, _utils.replacePlaceholders)(topTitle, answers),
    justify: 'center',
    size: 1,
    weight: 2,
    dataAttributes: {
      'data-test-id': 'page-topTitle'
    }
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(StyledTitle, {
    titleHeadingDesktopFontSize: titleHeadingDesktopFontSize,
    largeHeadingLineHeight: largeTitleHeadingLineHeight,
    smallHeadingLineHeight: smallTitleHeadingLineHeight
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: title,
    justify: 'center',
    weight: 3,
    size: titleHeadingSize,
    level: titleHeadingLevel,
    dataAttributes: {
      'data-test-id': 'page-title'
    }
  }))))), subtitle && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(StyledTitle, {
    largeHeadingLineHeight: largeSubtitleHeadingLineHeight,
    smallHeadingLineHeight: smallSubtitleHeadingLineHeight
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: (0, _utils.replacePlaceholders)(subtitle, answers),
    justify: 'center',
    size: 1,
    dataAttributes: {
      'data-test-id': 'page-subtitle'
    }
  })))));
};
var _default = QuestionTitle;
exports.default = _default;